import Footer from '@client-portal-common/Footer/Footer'

import { LoadingSpinner } from '@acre/design-system'

import { FooterContainer, FullPageLoadingContainer, SpinnerContainer } from './FullPageLoading.styles'

const FullPageLoading = () => (
  <FullPageLoadingContainer>
    <SpinnerContainer>
      <LoadingSpinner />
    </SpinnerContainer>
    <FooterContainer>
      <Footer variant="light" />
    </FooterContainer>
  </FullPageLoadingContainer>
)

export default FullPageLoading
